import ButtonT from '@components/tailwind-components/Button/ButtonT';
import type React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  retry: () => void;
}

export const FacebookErrorModal: React.FC<Props> = ({ retry }) => {
  const { t } = useTranslation();
  return (
    <div className='tailwind-modal-form'>
      <div className='tailwind-modal-body'>
        <p>{t('settings.facebook.error.title')}</p>
        <br />
        <p>{t('settings.facebook.error.body')}</p>
        <br />
        <strong>{t('settings.facebook.error.try-again')}</strong>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='submit'
          styling='primary'
          size='xs'
          rounding='md'
          onClick={() => retry()}>
          {t('settings.facebook.error.buttons.retry')}
        </ButtonT>
      </div>
    </div>
  );
};

export default FacebookErrorModal;
